import { useBondsBondFieldApi } from '../api';

export const useBondsBondSIssuerId = () => {
  const response = useBondsBondFieldApi('S_ISSUER.ID');
  return response;
};
